<ng-content select="td-wb-modal-header-toolbar" />
@if (iconId() !== undefined) {
  <td-wb-icon class="td-wb-modal-header__icon"
              [iconId]="iconId()"
              size="28" />
}
<ng-content select="td-wb-modal-header-title" />
<ng-content select="td-wb-modal-header-buttons" />
